module.exports = __webpack_public_path__ + "fonts/TheMix_cls_TT3_.15b2f807.eot";